@if (item) {
  <div
    class="community-item"
    [class.community-item--secondary]="variant === 'secondary'"
    [attr.data-post-id]="item.post_uuid"
    [dataTest]="'community-item-' + item.post_uuid"
  >
    <app-post-header
      [class.post-header--secondary]="variant === 'secondary'"
      [item]="item"
      [user]="currentUser"
      [isPostPinned]="isPostPinned"
      [feedType]="feedType"
      [isGuest]="isGuest"
      [isMajiApp]="isMajiApp"
      [profileLink]="profileLink"
      [openInSameWindow]="openProfileLinksInSameWindow"
      [enableExternalProfileLink]="enableExternalProfileLink"
    />

    <div class="content">
      @switch (postType) {
        @case (PostTypes.likedPlaylist) {
          <outlaw-post-playlist
            [item]="item"
            [variant]="variant"
            [isGuest]="isGuest"
            [isMajiApp]="isMajiApp"
            [openInSameWindow]="openProfileLinksInSameWindow"
            (loadingChange)="setLoading($event)"
            (watchMoreOpenDialog)="watchMoreOpenDialog.emit()"
            (navigateToPost)="onNavigateToPost()"
          />
        }
        @case (PostTypes.postedVideo) {
          <ng-container *ngTemplateOutlet="videoTemplate" />
        }

        @case (PostTypes.likedVideo) {
          <ng-container *ngTemplateOutlet="videoTemplate" />
        }
        @case (PostTypes.socialPost) {
          <app-social-media-post
            [item]="item"
            [variant]="variant"
            [isMajiApp]="isMajiApp"
            [openInSameWindow]="openProfileLinksInSameWindow"
            (navigateToPost)="onNavigateToPost()"
          />
        }
        @default {
          @if (item?.post_type?.slug === PostTypes.post && item.content.videos.length) {
            <ng-container *ngTemplateOutlet="videoTemplate" />
          } @else {
            <ol-post-text
              [item]="item"
              [variant]="variant"
              [isGuest]="isGuest"
              [isMajiApp]="isMajiApp"
              [openInSameWindow]="openProfileLinksInSameWindow"
              (navigateToPost)="onNavigateToPost()"
            />
          }
        }
      }
    </div>

    @if (!hideRecommendations && (item.liked_by?.length || isRepost)) {
      <app-recommendations
        [likedBy]="item.liked_by"
        [postOwner]="isRepost ? item.user : null"
        [postUuid]="item.post_uuid"
        [isGuest]="isGuest"
        [isMajiApp]="isMajiApp"
        [isPostMaji]="isPostMaji"
        [variant]="variant"
        (openRecommendedUsersDialogEvent)="openRecommendedUsersDialog()"
        (openGuestView)="openGuestView.emit()"
      />
    }

    @if (item.user_comment) {
      <app-post-comment
        [postId]="item.post_uuid"
        [commentText]="item.user_comment.content.text"
        [userInfo]="item.user_comment.user"
      />
    }

    @if (!loading()) {
      <app-post-actions
        [item]="item"
        [currentUser]="currentUser"
        [showFooter]="!isFollowEvent"
        [isOwner]="isOwner"
        [isGuest]="isGuest"
        [isMajiApp]="isMajiApp"
        [variant]="variant"
        (itemChange)="item = $event"
        (ownerAction)="ownerAction($event)"
        (shareLinkCopied)="shareLinkCopied.emit()"
        (openGuestView)="openGuestView.emit()"
        (navigateToPost)="onNavigateToPost($event)"
        (saveToggled)="saveToggled.emit($event)"
      />
    }
  </div>
}

<ng-template #videoTemplate>
  <app-post-video
    [item]="item"
    [isGuest]="isGuest"
    [isMajiApp]="isMajiApp"
    [variant]="variant"
    [openInSameWindow]="openProfileLinksInSameWindow"
    (navigateToPost)="onNavigateToPost()"
  />
</ng-template>
